import React from "react";
import AccessibilityFolaCommon from "@/features/settings/AccessibilityFolaCommon.jsx";

export default function AccessibilityFola() {
  return <AccessibilityFolaCommon role="patient" />;
}
